import React from 'react';
import PropTypes from 'prop-types';

import { CheckboxType } from '@mlb/react-patterns/components/Checkbox/checkbox.types';

import Baserunners from './Baserunners';
import DateCombined from './DateCombined';
import DateInput from './DateInput';
import DateRange from './DateRange';
import MultiSelect from './MultiSelect';
import Players from './Players';
import RadioGroup from './RadioGroup';
import RangeSlider from './RangeSlider';
import SingleSelect from './SingleSelect';
import StrikeZone from './StrikeZone';
import Teams from './Teams';
import TypeaheadMultiSelect from './TypeaheadMultiSelect';

export const FILTER_TYPES = {
    baserunners: 'BASERUNNERS',
    dateCombined: 'DATE_COMBINED',
    dateInput: 'DATE_INPUT',
    dateRange: 'DATE_RANGE',
    multiSelectButtons: 'MULTI_SELECT_BUTTONS',
    multiSelectCheckbox: 'MULTI_SELECT_CHECKBOXES',
    players: 'PLAYERS',
    radioGroup: 'RADIO_GROUP',
    rangeSlider: 'RANGE_SLIDER',
    singleSelectDropdown: 'SINGLE_SELECT_DROPDOWN',
    strikeZone: 'STRIKE_ZONE',
    teams: 'TEAMS',
    typeaheadMultiSelect: 'TYPEAHEAD_MULTI_SELECT',
};

const Filter = ({
    type,
    ...otherProps
}) => {

    let component;

    switch (type) {

        case (FILTER_TYPES.baserunners):
            component = <Baserunners {...otherProps} />;
            break;

        case (FILTER_TYPES.dateCombined):
            component = <DateCombined {...otherProps} />;
            break;

        case (FILTER_TYPES.dateInput):
            component = <DateInput {...otherProps} />;
            break;

        case (FILTER_TYPES.dateRange):
            component = <DateRange {...otherProps} />;
            break;

        case (FILTER_TYPES.multiSelectButtons):
            component = <MultiSelect type={CheckboxType.PILL} {...otherProps} />;
            break;

        case (FILTER_TYPES.multiSelectCheckbox):
            component = <MultiSelect type={CheckboxType.CHECKBOX} {...otherProps} />;
            break;

        case (FILTER_TYPES.players):
            component = <Players {...otherProps} />;
            break;

        case (FILTER_TYPES.radioGroup):
            component = <RadioGroup {...otherProps} />;
            break;

        case (FILTER_TYPES.rangeSlider):
            component = <RangeSlider {...otherProps} />;
            break;

        case (FILTER_TYPES.singleSelectDropdown):
            component = <SingleSelect {...otherProps} />;
            break;

        case (FILTER_TYPES.strikeZone):
            component = <StrikeZone {...otherProps} />;
            break;

        case (FILTER_TYPES.teams):
            component = <Teams {...otherProps} />;
            break;

        case (FILTER_TYPES.typeaheadMultiSelect):
            component = <TypeaheadMultiSelect {...otherProps} />;
            break;

        default:
            component = null;

    };

    return component;

};

Filter.propTypes = {
    type: PropTypes.string.isRequired,
};

export default Filter;
